export default __webpack_public_path__ + "static/media/Bristol-Myers Squibb.48e7b45d.png";